<template>
  <div class="workspace">
    <div class="section-heading">
      <h2>Orders</h2>
    </div>
    <div class="order-search">
      <div class="order-search-heading"><h3>Order Search</h3></div>
      <div class="order-search-form">
        <div>
          <input placeholder="Order # or Customer" type="search" v-model="searchString"/>
        </div>
        <div>
          <button @click="searchOrders">Search</button>
        </div>
      </div>

    </div>


    <!--Order List Table Start-->
    <div class="orders-body">
      <a :href="`/order-details/${order.id}`" v-for="order in displayList" :key="order.id">
      <div class="order-item" v-if="order.customer">
        <div class="order-item-left">
          <div><span>#{{ order.id }}</span><br>{{ order.customer.name }} {{ order.customer.last_name }}</div>
          <div>{{ changeDateTimeFormat(order.order_date) }}</div>
          <div>${{ order.total_amount }}</div>
        </div>
        <div class="order-item-right">
          <div v-if="!isCatering(order)" class="order-status" :class="order.status === 1 ? 'new' : ''"><span>{{ order.status === 5 ? 'Completed' : order.status_name }}</span></div>
            <div v-else class="order-status new"><span>Catering Order</span></div>
          <button type="button" class="order-item-detail-button">View Details</button>
        </div>
      </div>
    </a>
    </div>

    <!--<div class="order-list">
      <div class="order-list-header">
        <div class="order-list-header-item">Order #</div>
        <div class="order-list-header-item">Date</div>
        <div class="order-list-header-item">Customer Name</div>
        <div class="order-list-header-item">Delivery Method</div>
        <div class="order-list-header-item">Total</div>
        <div class="order-list-header-item">Status</div>
      </div>
      <div class="order-list-body">
        <a :href="`/order-details/${order.id}`" v-for="order in displayList" :key="order.id">


          <div v-if="order.customer" class="order-list-row" >
            <div class="order-list-body-item">{{ order.id }}</div>
            <div class="order-list-body-item">{{ order.order_date.split(' ')[0] }}</div>
            <div class="order-list-body-item">{{ order.customer.name }} {{ order.customer.last_name }}</div>
            <div class="order-list-body-item">{{ order.delivery_type_name }}</div>
            <div class="order-list-body-item">$ {{ order.total_amount }}</div>
            <div v-if="!isCatering(order)" class="order-list-body-item" :class="order.status === 1 ? 'new' : ''"><span>{{ order.status === 5 ? 'Completed' : order.status_name }}</span></div>
            <div v-else class="order-list-body-item new"><span>Catering Order</span></div>
          </div>
        </a>
      </div>
      <div class="pagination flex" v-if="displayListSource.length > itemCount">
        <div @click="pageDown">&laquo;</div>
        <div class="cursor-pointer" @click="pageCount = page - 1" v-for="(page, index) in pageArray" :key="index" :class="page === pageCount + 1 ? 'active' : ''">{{page}}</div>
        <div @click="pageUp">&raquo;</div>
      </div>
    </div>-->
    <!--Order List Table End-->
  </div>
</template>

<script>

export default {
  components: {
  },
  data () {
    return {
      selected: [],
      // products: [],
      itemsPerPage: 10,
      isMounted: false,

      pageCount: 0,
      itemCount: 10,
      sort_by_date: false,
      // Data Sidebar
      addNewDataSidebar: false,
      sidebarData: {},
      user_group: {label: 'Select a restaurant', value: 0},
      user_group_options: [],
      restaurantId: -1,
      searchString: '',
      searched: []
    }
  },
  computed: {
    pageArray () {
      const array = JSON.parse(JSON.stringify(this.displayListSource))
      const page_array = []
      let i = 0
      const max_page = Math.ceil(array.length / this.itemCount)
      for (i = 0; i < max_page; i++) {
        page_array.push(parseInt(i) + 1)
      }
      return page_array
    },
    currentPage () {
      if (this.isMounted) {
        return this.$refs.table.currentx
      }
      return 0
    },
    queriedItems () {
      return this.$refs.table ? this.$refs.table.queriedResults.length : this.orders.length
    },
    restaurantlist () {
      return this.$store.state.api.restaurantlist
    },
    orders () {
      return this.$store.state.api.orders
    },
    orderStatusChanged () {
      return this.$store.state.api.orderStatusChanged
    },
    orderList () {
      let orders = JSON.parse(JSON.stringify(this.$store.state.api.orders))
      orders = orders.filter(order => {
        if (order.customer) {
          return order
        }
      })
      return orders.reverse()
    },

    displayList () {
      let array = JSON.parse(JSON.stringify(this.displayListSource))
      if (this.sort_by_date) {
        array = array.sort((a, b) => {
          // Turn your strings into dates, and then subtract them
          // to get a value that is either negative, positive, or zero.
          return new Date(b.order_date) - new Date(a.order_date)
        })
      }
      return array.splice(this.pageCount * this.itemCount, this.itemCount)
    },
    displayListSource () {
      return this.searched.length > 0 ? this.searched : this.orderList
    },
    order_by_date () {
      return this.$store.state.api.order_by_date
    },
    selectedRestaurant () {
      let obj = this.$store.state.api.selectedRestaurant
      if (!obj) {
        try {
          obj = JSON.parse(localStorage.getItem('selectedRestaurant'))
        } catch (e) {
          obj = null
        }

      }
      return obj
    }
  },
  watch: {
    searchString () {
      this.searchOrders()
    },
    '$store.state.api.selectedRestaurant' (val) {
      if (val) {
        this.handleData()
      }
    },
    sort_by_date () {
      this.$store.commit('api/SET_ORDER_BY', this.sort_by_date)
    }
  },
  methods: {
    isCatering (order) {
      const has_catering_products = order.orderProduct.filter(item => {
        if (item.product[0].is_catering) {
          return item
        }
      })
      return has_catering_products.length > 0
    },
    pageUp () {
      if (this.pageCount !== this.displayListSource.length) {
        this.pageCount += 1
      }
    },
    pageDown () {
      if (this.pageCount !== 0) {
        this.pageCount -= 1
      }
    },
    filterOrders (order, query) {
      return order.customer.name.toLowerCase().includes(query.toLowerCase()) || order.id.toString().includes(query.toLowerCase())
    },
    searchOrders () {
      this.searched = this.orderList.filter((order) => this.filterOrders(order, this.searchString))
    },
    addNewData () {
      this.sidebarData = {}
      this.toggleDataSidebar(true)
    },
    deleteData (id) {
      this.$store.dispatch('dataList/removeItem', id).catch(err => { console.error(err) })
    },
    editData (data) {
      // this.sidebarData = JSON.parse(JSON.stringify(this.blankData))
      this.sidebarData = data
      this.toggleDataSidebar(true)
    },
    getOrderStatusColor (status) {
      if (status === 0)   return 'status-0'
      if (status === 1) return 'status-1'
      if (status === 2)  return 'status-2'
      if (status === 3)  return 'status-3'
      if (status === 4)  return 'status-4'
      if (status === 5)  return 'status-5'
      if (status === 6)  return 'status-6'
      return 'primary'
    },
    toggleDataSidebar (val = false) {

      if (!val) {
        if (this.orderStatusChanged) {
          this.getOrderList()
          this.$store.commit('api/SET_ORDER_STATUS_CHANGED', false)
        }
      }
      this.addNewDataSidebar = val
    },
    getOrderList () {
      const payload = {
        restaurantId: this.restaurantId,
        page: 1
      }

      this.$vs.loading()

      this.$store.dispatch('api/getOrders', payload)
        .then(() => {
          this.$vs.loading.close()
        })
        .catch(error => {
          this.$vs.loading.close()
          this.$vs.notify({
            title: 'Error',
            text: error.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })
    },
    getOrderStatuses () {
      this.$store.dispatch('api/getOrderStatuses')
        .then(() => {
        })
        .catch(error => {
          this.$vs.notify({
            title: 'Error',
            text: error.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })
    },
    handleData () {
      this.restaurantId = this.selectedRestaurant.id
      this.getOrderList()
    }
  },
  created () {
  },
  mounted () {
    this.isMounted = true
    this.getOrderStatuses()
    if (this.selectedRestaurant) {
      this.handleData()
    }
    this.sort_by_date = this.order_by_date
  }
}
</script>

<style lang="scss">
.orders-body {
  display:flex;
  flex-wrap: wrap;
  gap:20px;
  width: 100%;
  a {
    width:100%;
  }
}
  .order-item {
    display:flex;
    width:100%;
    justify-content: space-between;
    align-items: center;
    border-radius:3px;
    box-shadow:0px 0px 5px 2px rgba(0,0,0,0.1);
    padding:20px;
    transition:all .2s ease;
    &:hover, &:active, &:focus {
      background-color:#f9f9f9;
      box-shadow:0px 0px 5px 1px rgba(0,0,0,0.2);
    }
  }
  .order-item-detail-button{
    border:none;
    border-radius: 3px;
    color:#fff;
    background-color:#0070eb;
    padding:5px 10px;
  }
  .order-item-left{
    div:first-child{
      span{
        font-weight: bold;
      }
    }
    div:nth-child(2){
      font-weight: bold;
      font-style:italic;
    }
  }
  .order-item-right{
  .order-status {
      width:100%;
      border-radius: 3px;
      border:1px solid #ccc;
      text-align: center;
      margin-bottom:15px;
    }
  }
  .order-search{
    padding:20px;
    border-radius:3px;
    box-shadow:0px 0px 5px 2px rgba(0,0,0,0.1);
    margin-top:20px;
    margin-bottom:20px;
  }
  .order-search-form{
    display:flex;
    flex-wrap: wrap;
    gap:10px;
    width:100%;
    div{
      width:100%;
    }
    input[type="search"]{
      width:100%;
      border:1px solid #ccc;
      border-radius: 3px;
      padding:5px 10px;
      background-color:#f5f5f5;
    }
    button{
      width:100%;
      border:none;
      padding:5px 0px;
      background-color:#13aa37;
      color:#fff;
      border-radius: 3px;
    }
  }

</style>
